import Vue from 'vue'
import Vuex from 'vuex'
import modules from '@/global/loaders/stores'
import MapTypeStore from '@/global/components/map/tile-layers/store'
const componentsModules = {
  'map-type': MapTypeStore
}

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: {
    isMenuNavOpen: false
  },
  mutations: {
    toggleMenuNav (state, status) {
      state.isMenuNavOpen = status
    }
  },
  actions: {},
  modules: {
    ...modules,
    ...componentsModules
  }
})

export default store
